export default __webpack_public_path__ + "static/media/2414.94f08099.png";